import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import responseHandler from "@/plugins/errorHandling";

export interface IUserImported{
  line: number,
  code_import: number,
  email: string,
  first_name: string,
  last_name: string,
  locker_id: number,
  phone_number: string;
}

interface UserImportState {
  importResults: IUserImported[];
  importLockers: ILocker[];
  errors: IErrors;
}

const state: UserImportState = {
  importLockers: [],
  importResults: [],
  errors: {},
};

const getters: GetterTree<UserImportState, RootState> = {
  importLockers: (state): ILocker[] => state.importLockers,
  importResults: (state) => state.importResults,
  errors: (state) => state.errors,
};

const actions: ActionTree<UserImportState, RootState> = {
  fetchImportLockers: ({commit}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'users/import/lockers',
      method: 'GET'
    }),
    commit,
    'importLockersLoaded'
  ),
  importUsers: ({ commit }, {file, lockerId}): any => {
    const formData = new FormData();
    formData.append('csv', file);
    commit('usersImported', {});

    return responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'users/import/'+lockerId,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }),
      commit,
      'usersImported'
    )
  },
  exportUsers: ({ commit }, lockerId: number|null): any => {
    return responseHandler.handleDownload(
      () => axios({
        url: settings.endpoint + 'users/export.csv',
        method: 'POST',
        responseType: 'blob',
        data: lockerId ? {locker_id: lockerId} : {}
      }),
      commit,
      'exportUsersLoaded',
      'users.csv'
    )
  },
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
};

const mutations: MutationTree<UserImportState> = {
  importLockersLoaded(state, payload) {
    state.importLockers = payload;
  },
  exportUsersLoaded() {
    // do nothing, needed to keep commit() and trigger event correctly
  },
  usersImported(state, payload) {
    state.importResults = payload;
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
};

const namespaced: boolean = true;

export const userImportModule: Module<UserImportState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
